export default "__VITE_ASSET__u6mCtcr8__"